import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "admin-audit" }
const _hoisted_2 = { class: "admin-audit__summary" }
const _hoisted_3 = { class: "admin-audit__summary-counts" }
const _hoisted_4 = { class: "admin-audit__search" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "admin-audit__section" }
const _hoisted_7 = { class: "admin-audit__section-title" }
const _hoisted_8 = { class: "admin-audit__section" }
const _hoisted_9 = { class: "admin-audit__section-title" }
const _hoisted_10 = {
  key: 0,
  class: "admin-audit__notice"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderBlock = _resolveComponent("HeaderBlock")!
  const _component_AoAuditConfigTable = _resolveComponent("AoAuditConfigTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_HeaderBlock, {
      title: _ctx.t('audit.title')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t("audit.summary", _ctx.summaryCounts)), 1)
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
        type: "text",
        class: "admin-audit__search-input",
        placeholder: _ctx.t('audit.searchPlaceholder')
      }, null, 8, _hoisted_5), [
        [_vModelText, _ctx.searchTerm]
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.t("audit.sections.orcha")), 1),
      _createVNode(_component_AoAuditConfigTable, {
        tables: _ctx.filtered(_ctx.orchaTables),
        loading: _ctx.orchaLoading && _ctx.orchaTables.length === 0,
        error: _ctx.orchaError,
        onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onUpdate('orcha', $event)))
      }, null, 8, ["tables", "loading", "error"])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.t("audit.sections.fides")), 1),
      (_ctx.fidesNotAvailable)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.t("audit.fidesUnavailable")), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_AoAuditConfigTable, {
        tables: _ctx.filtered(_ctx.fidesTables),
        loading: _ctx.fidesLoading && _ctx.fidesTables.length === 0,
        error: _ctx.fidesError,
        disabled: _ctx.fidesNotAvailable,
        onUpdate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onUpdate('fides', $event)))
      }, null, 8, ["tables", "loading", "error", "disabled"])
    ])
  ]))
}